<template>
  <div class="loading-container">
    <div class="wrap-screen w-100 h-100">
      <img :src="`/svg-loaders/ball-triangle.svg`" width="60" alt="">
      <div class="title-loading color-white">Please Wait . . . .</div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'

export default {
  name: 'loading',
  data: function () {
    return {
      linkData: ''
    }
  }
}
</script>